/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-19 16:29:29
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-20 12:08:24
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/Query1/Filter/DropDown/index.tsx
 */
import React from 'react';
import css from './css.module.less';
import DropDown from '@/src/components/Antd/DropDown/DropDown';
import { queryMenuId } from 'src/tools/constant';
import Trigger from './Trigger';

const HOCWrapper = (Component, obj) => {
  const { name, idExtra } = obj;
  const FilterDrop = (props) => {
    const [visible, setVisible] = React.useState(false);

    const { dropdownProps = {}, ...rest } = props;
    const {
      maxWidth,
      maxHeight,
      name: _name,
      idExtra: idExtra1,
    } = dropdownProps;
    return (
      <DropDown
        visible={visible}
        onVisibleChange={setVisible}
        className={css.filterDrop}
        maxWidth={maxWidth || 300}
        maxHeight={maxHeight || 300}
        overlay={
          <div className={css.contentContainer}>
            <Component
              {...rest}
              onDropDownChange={setVisible}
              dropDownVisible={visible}
            />
          </div>
        }
        trigger={['click']}>
        <div>
          <Trigger
            name={_name || name}
            {...(idExtra1 || idExtra
              ? { id: `${queryMenuId}${idExtra || ''}${idExtra1 || ''}` }
              : {})}
          />
        </div>
      </DropDown>
    );
  };
  return FilterDrop;
};

export default HOCWrapper;
